import { ISnotrRoute } from '..';

export default [
  {
    path: '/products',
    name: 'Products',
    meta: {
      title: 'TabTitle.products',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/products.vue'),
  },
  {
    path: '/products/variant-grouping',
    name: 'ProductVariantHolders',
    meta: {
      title: 'TabTitle.productVariantHolders',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/product-variant-holders.vue'),
  },
  {
    path: '/historic-vat-rates',
    name: 'HistoricVatRates',
    meta: {
      title: 'TabTitle.historicVatRates',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/historic-vat-rates.vue'),
  },
] as ISnotrRoute[];
